/**
 * Ícone + cor por tipo de entrega — fonte única para os dropdowns de entrega
 * (PlanManager, DefaultDeliveryCard, Downsell). O `label` de cada tipo varia
 * por contexto (cada tela monta suas próprias options usando este mapa).
 */
import { Crown, MessageSquare, Link, Zap, RotateCcw } from 'lucide-react';

export const DELIVERY_TYPE_META = {
    // "default" = herda a entrega do nível acima (cascata) — não é "Grupo VIP"
    // por si só, mesmo que na prática costume terminar lá. Mesmo ícone do botão
    // "voltar ao padrão" (DeliveryTypeField) — padronizado em todos os contextos.
    default: { icon: RotateCcw, colorClass: 'text-white/40' },
    // "vip_group" = Grupo VIP explícito — escolha absoluta, não cascateia.
    vip_group: { icon: Crown, colorClass: 'text-[#a78bfa]' },
    message_only: { icon: MessageSquare, colorClass: 'text-blue-400' },
    external_link: { icon: Link, colorClass: 'text-emerald-400' },
    only_upsell: { icon: Zap, colorClass: 'text-yellow-400' },
};
